import TextBox from './QuestionTextBox';
import ConsultantBox from './ConsultantBox';
var Boxes = {
    default: TextBox,
    consultant: ConsultantBox
};
export default Boxes;
